export default __webpack_public_path__ + "static/media/Bajaj2.e279a309.jpg";